import type { GatewayBrowserClient } from "../gateway.ts";

export type ModelChoice = {
  id: string;
  name: string;
  provider: string;
  contextWindow?: number;
  reasoning?: boolean;
};

export type ModelCatalogState = {
  client: GatewayBrowserClient | null;
  connected: boolean;
  modelCatalogAll: ModelChoice[];
  modelCatalogLoading: boolean;
};

export async function loadModelCatalog(state: ModelCatalogState) {
  if (!state.client || !state.connected) {
    return;
  }
  if (state.modelCatalogLoading) {
    return;
  }
  state.modelCatalogLoading = true;
  try {
    const res = await state.client.request<{ models?: ModelChoice[] }>("models.list", {});
    if (res && Array.isArray(res.models)) {
      state.modelCatalogAll = res.models;
    }
  } catch {
    // Silently ignore -- model catalog is optional enhancement
  } finally {
    state.modelCatalogLoading = false;
  }
}
